import { render, staticRenderFns } from "./tglb.vue?vue&type=template&id=880a7f12&scoped=true&"
import script from "./tglb.vue?vue&type=script&lang=js&"
export * from "./tglb.vue?vue&type=script&lang=js&"
import style0 from "./tglb.vue?vue&type=style&index=0&id=880a7f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880a7f12",
  null
  
)

export default component.exports